import axios from "axios";

/**
 *
 */

const Portal_Page_Update_Content = "PortalKey/Portal_Page_Update_Content";


export const portalKey = (state = {
  platformKey: ""
}, action) => {
  switch (action.type) {
    case Portal_Page_Update_Content:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    default:
      return state;
  }
};

export const updateKey = () => (dispatch) => {
  axios(`/getFoundationUrl`).then(
    response => response.data
  ).then(
    page => {
      dispatch(update({
          name:"platformKey",
          value:page
        }
      ));
    }
  );
};

function update (data) {
  return {
    type: Portal_Page_Update_Content,
    data: data
  }
};
